import { del, get, post, postFormData, put } from './api.service';

const base_url = 'contracts/v1';

export const getAll = (params: {
        page?: number,
        per_page?: number,
        search?: string,
        status?: string,
        customer_id?: number,
        payment_method?: string,
        order?: string,
        date?: string,
        period?: string,
} = {}) => {
    const queryString = Object.keys(params)
        .filter(key => params[key as keyof typeof params])
        .map(key => {
            return `${key}=${params[key as keyof typeof params]}`;
        }).join('&');

    let url = queryString ? base_url + `?${queryString}` : base_url;

    return get(url);
}

export const getById = (uuid: string) => {
    return get(`${base_url}/${uuid}`);
}

export const create = (data: object) => {
    return post(base_url, data);
}

export const update = (data: { values: object, uuid: string }) => {
    return put(`${base_url}/${data.uuid}`, data.values);
}

export const updateStatus = (data: { values: object, uuid: string }) => {
    return put(`${base_url}/${data.uuid}/status`, data.values);
}

export const remove = (uuid: string | undefined) => {
    return del(`${base_url}/${uuid}`);
}

export const importContracts = (data: object) => {
  return postFormData(`${base_url}/import`, data);
};
